import script from "./BuyTicketBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuyTicketBanner.vue?vue&type=script&setup=true&lang=ts"

import "./BuyTicketBanner.vue?vue&type=style&index=0&id=4b5356c8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b5356c8"]])

export default __exports__